var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReplace = function SvgReplace(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1160_995)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3332 0C13.7014 0 13.9998 0.298477 13.9998 0.666667V4C13.9998 4.36819 13.7014 4.66667 13.3332 4.66667H9.99984C9.63165 4.66667 9.33317 4.36819 9.33317 4C9.33317 3.63181 9.63165 3.33333 9.99984 3.33333H12.6665V0.666667C12.6665 0.298477 12.965 0 13.3332 0Z",
    fill: "#6E6D86"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33317 16C1.96498 16 1.6665 15.7015 1.6665 15.3333L1.6665 12C1.6665 11.6318 1.96498 11.3333 2.33317 11.3333H5.6665C6.03469 11.3333 6.33317 11.6318 6.33317 12C6.33317 12.3682 6.03469 12.6667 5.6665 12.6667H2.99984L2.99984 15.3333C2.99984 15.7015 2.70136 16 2.33317 16Z",
    fill: "#6E6D86"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.979 3.57628C12.2497 3.82998 12.6724 3.86524 12.9522 3.62167C13.2277 3.38178 13.2607 2.9621 12.9993 2.70678C10.7069 0.467063 7.12127 -0.0757198 4.2094 1.60545C1.60676 3.10808 0.273655 5.96517 0.586404 8.7723C0.62871 9.15202 1.00659 9.38486 1.37655 9.28939C1.721 9.2005 1.93184 8.85789 1.89962 8.50361C1.69431 6.24591 2.78381 3.96811 4.87606 2.76015C7.22124 1.40616 10.1005 1.8153 11.979 3.57628Z",
    fill: "#6E6D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3534 7.18921C13.9744 7.21629 13.699 7.55609 13.7013 7.93607C13.7138 10.0223 12.6364 12.0561 10.7004 13.1738C8.35524 14.5278 5.47594 14.1187 3.59744 12.3577C3.3268 12.104 2.90409 12.0687 2.6243 12.3123C2.34874 12.5522 2.31582 12.9719 2.57715 13.2272C4.86962 15.4669 8.45521 16.0097 11.3671 14.3285C13.7792 12.9359 15.1008 10.3799 15.0324 7.77852C15.0231 7.42298 14.7082 7.16387 14.3534 7.18921Z",
    fill: "#6E6D86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1160_995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReplace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/replace.e14e9815927cd1aa63e59368372e2c87.svg";